// Controlador para Catálogo de Motivos de Rechazo
// Siguiendo MODO1: cat_motivos_rechazo_controller
import axios from 'axios';
import { getApiUrl } from '@/config/api';
import authService from '@/shared/services/auth';

export default class CatMotivosRechazoService {
  constructor() {
    this.motivosRechazo = [];
    this.loading = false;
    this.error = null;
    this.selectedEmpresa = null;
  }

  // Inicializar el servicio
  async initialize() {
    // Esperar un poco para que la empresa se seleccione
    await this.waitForEmpresa();
    await this.listar();
  }

  // Esperar a que la empresa esté seleccionada
  async waitForEmpresa() {
    let attempts = 0;
    const maxAttempts = 50; // 5 segundos máximo
    
    while (attempts < maxAttempts) {
      this.selectedEmpresa = authService.getSelectedEmpresa();
      if (this.selectedEmpresa && this.selectedEmpresa.EmpresaId) {
        console.log('Empresa encontrada para CatMotivosRechazo:', this.selectedEmpresa);
        return;
      }
      
      // Esperar 100ms antes del siguiente intento
      await new Promise(resolve => setTimeout(resolve, 100));
      attempts++;
    }
    
    // Si no se encuentra empresa después de los intentos
    this.error = 'No se pudo obtener la empresa seleccionada';
    console.error('No se pudo obtener empresa para CatMotivosRechazo después de', maxAttempts, 'intentos');
  }

  // Listar motivos de rechazo
  async listar() {
    this.loading = true;
    this.error = null;
    
    try {
      // Verificar que tenemos empresa seleccionada
      if (!this.selectedEmpresa || !this.selectedEmpresa.EmpresaId) {
        this.selectedEmpresa = authService.getSelectedEmpresa();
        if (!this.selectedEmpresa || !this.selectedEmpresa.EmpresaId) {
          this.loading = false;
          return { success: false, data: [], message: 'Debe elegir una empresa antes de poder continuar.' };
        }
      }

      const token = authService.getToken();
      if (!token) {
        throw new Error('No hay token de autenticación');
      }

      console.log('Cargando motivos de rechazo para empresa:', this.selectedEmpresa.EmpresaId);

      const response = await axios.post(getApiUrl('/api/MotivoRechazo/listar'), {
        EmpresaId: this.selectedEmpresa.EmpresaId
      }, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      
      // Filtrar por empresa en el frontend como medida de seguridad adicional
      const allMotivosRechazo = response.data || [];
      this.motivosRechazo = allMotivosRechazo.filter(motivosRechaz => motivosRechaz.EmpresaId === this.selectedEmpresa.EmpresaId);
      this.loading = false;
      
      console.log('MotivosRechazo cargados:', this.motivosRechazo.length, 'de', allMotivosRechazo.length, 'total');
      console.log('Empresa del usuario:', this.selectedEmpresa.EmpresaId);
      this.loading = false;
      
      console.log('Motivos de rechazo cargados:', this.motivosRechazo.length);
      
      return {
        success: true,
        data: this.motivosRechazo,
        message: 'Motivos de rechazo cargados exitosamente'
      };
    } catch (error) {
      console.error('Error al cargar motivos de rechazo:', error);
      this.error = error.message;
      this.motivosRechazo = [];
      this.loading = false;
      throw error;
    }
  }

  // Guardar motivo de rechazo (insert/update)
  async guardar(motivoRechazo) {
    try {
      const token = authService.getToken();
      if (!token) {
        throw new Error('No hay token de autenticación');
      }

      const response = await axios.post(getApiUrl('/api/MotivoRechazo/guardar'), motivoRechazo, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      // Recargar la lista después de guardar
      await this.listar();
      
      return {
        success: true,
        data: response.data,
        message: motivoRechazo.Motivo_rechazo_cod ? 'Motivo de rechazo actualizado exitosamente' : 'Motivo de rechazo creado exitosamente'
      };
    } catch (error) {
      console.error('Error al guardar motivo de rechazo:', error);
      throw error;
    }
  }

  // Borrar motivo de rechazo
  async borrar(motivoRechazo) {
    try {
      const token = authService.getToken();
      if (!token) {
        throw new Error('No hay token de autenticación');
      }

      const response = await axios.post(getApiUrl('/api/MotivoRechazo/borrar'), motivoRechazo, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      // Recargar la lista después de eliminar
      await this.listar();
      
      return {
        success: true,
        data: response.data,
        message: 'Motivo de rechazo eliminado exitosamente'
      };
    } catch (error) {
      console.error('Error al eliminar motivo de rechazo:', error);
      throw error;
    }
  }

  // Leer un motivo de rechazo específico
  async lectura(clave) {
    try {
      const token = authService.getToken();
      if (!token) {
        throw new Error('No hay token de autenticación');
      }

      const response = await axios.post(getApiUrl('/api/MotivoRechazo/lectura'), {
        Motivo_rechazo_cod: clave
      }, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      return {
        success: true,
        data: response.data,
        message: 'Motivo de rechazo encontrado'
      };
    } catch (error) {
      console.error('Error al leer motivo de rechazo:', error);
      throw error;
    }
  }

  // Recargar motivos de rechazo
  async recargar() {
    await this.listar();
  }

  // Descarga masiva
  async downloadBulk() {
    // TODO: Implementar endpoint de descarga en el backend
    throw new Error('Funcionalidad de descarga no implementada en el backend');
  }
}
